import { makeStyles } from '@material-ui/core'

// Name | Cut-off | Description | actions. The header and the row share this so their columns line up.
export const COLUMNS = '8fr 4fr 20fr 1fr'

// Only the grids differ from the cancel-policy list; every other class comes from its styles.
const useStyles = makeStyles((theme) => ({
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: COLUMNS.slice(0, COLUMNS.lastIndexOf(' ')),
    height: 'auto',
    minHeight: 100,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  deleteIcon: {
    fontSize: 42
  }
}))

export default useStyles
